import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { SellPointDataSearch, SellPointsParams } from '@Types/SellPointsSearch';
import type { ApiResponse } from '@Types/Api';

export interface Response {
  sellPoints: SellPointDataSearch[];
}

async function getSellPointsSearch({ params, pickupPoint }: SellPointsParams) {
  const searchParams = new URLSearchParams();

  if (pickupPoint) searchParams.append('storage', 'true');
  if (params) searchParams.append('q', params);

  const url = `/backend/showroom/get-sell-points-list?${searchParams.toString()}`;

  const res = await Api.queryProxi<ApiResponse<Response>>(url, { method: 'GET' });

  if (!res.ok) throw new BackendError(url, res);
  return res.data;
}

export default getSellPointsSearch;
